import { logger } from './logger';

/**
 * 音声管理クラス（Web Audio APIを使用）
 */
export class SoundManager {
  private audioContext: AudioContext | null = null;
  private enabled: boolean = true;

  constructor() {
    // AudioContextを初期化（ユーザーインタラクション後に有効化される）
    this.initAudioContext();
  }

  /**
   * AudioContextを初期化
   */
  private initAudioContext(): void {
    try {
      this.audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
    } catch (error) {
      logger.warn('AudioContext initialization failed:', error);
      this.enabled = false;
    }
  }

  /**
   * AudioContextを有効化（ユーザーインタラクション後に呼び出す）
   */
  public enableAudioContext(): void {
    if (this.audioContext && this.audioContext.state === 'suspended') {
      this.audioContext.resume();
    }
  }

  /**
   * ビープ音を生成して再生
   */
  private playBeep(frequency: number, duration: number, type: OscillatorType, volume: number = 0.2): void {
    if (!this.enabled || !this.audioContext) return;

    try {
      // AudioContextがsuspended状態の場合は有効化を試みる
      if (this.audioContext.state === 'suspended') {
        this.audioContext.resume();
      }

      const oscillator = this.audioContext.createOscillator();
      const gainNode = this.audioContext.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(this.audioContext.destination);

      oscillator.frequency.value = frequency;
      oscillator.type = type;

      const currentTime = this.audioContext.currentTime;
      gainNode.gain.setValueAtTime(volume, currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, currentTime + duration);

      oscillator.start(currentTime);
      oscillator.stop(currentTime + duration);
    } catch (error) {
      logger.warn('Sound playback failed:', error);
    }
  }

  /**
   * ジャンプ音を再生
   */
  public playJump(): void {
    // 高い音の短いビープ音
    this.playBeep(200, 0.1, 'sine', 0.35);
  }

  /**
   * 衝突音を再生
   */
  public playCollision(): void {
    // 低い音の長いビープ音（音量を小さく）
    this.playBeep(100, 0.3, 'square', 0.15);
  }

  /**
   * 音声の有効/無効を設定
   */
  public setEnabled(enabled: boolean): void {
    this.enabled = enabled;
  }

  /**
   * 音声が有効かどうかを取得
   */
  public isEnabled(): boolean {
    return this.enabled;
  }
}

